<template>
  <van-tabbar route
  :border="true"
  :fixed="true"
  :placeholder="true"

  >
    <van-tabbar-item replace to="/home">
      <span>{{ $t('footer.home') }}</span>
      <template #icon>
        <img src="@/assets/footer/index.png" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/exchange">
      <span>{{ $t('exchangeb.title') }}</span>
      <template #icon>
        <img src="@/assets/footer/exchange.png" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/trade">
      <span>{{ $t('footer.exchange') }}</span>
      <template #icon>
        <img src="@/assets/footer/trade.png" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/lockming">
      <span>{{ $t('home.menu7') }}</span>
      <template #icon>
        <img src="@/assets/footer/locking.png" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/assets">
      <span>{{ $t('footer.assets') }}</span>
      <template #icon>
        <img src="@/assets/footer/assets.png" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'WapFooter'
}
</script>

<style></style>
